<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 account_section">
    <div class="my-account-title">Account Information</div>
    <div class="account_login_info">
      <div class="row">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
          <label class="account_label">Account ID</label>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
          <p class="account_p">{{AccountView.evfAccountNumber}}</p>
        </div>
      </div>
      <div class="row" v-show="FormInputs.ContactLegalName">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
          <label class="account_label" v-if="FormInputs.BusinessLabels">Business/Practice Name</label>
          <label class="account_label" v-else>Organization Name</label>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
          <p class="account_p capitalized-text">{{AccountView.primaryContact.legalName}}</p>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
          <label class="account_label capitalized-text" v-if="FormInputs.BusinessLabels || FormInputs.NonProfitLabels">Primary Contact</label>
          <label class="account_label capitalized-text" v-else>Participant Name</label>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
          <p class="account_p" v-if="(AccountView.primaryContact.suffix == 'N/A' ||  AccountView.primaryContact.suffix == '')">{{AccountView.primaryContact.firstName + " " + AccountView.primaryContact.lastName}}</p>
          <p v-else class="account_p">{{AccountView.primaryContact.firstName + " " + AccountView.primaryContact.lastName + ", " + AccountView.primaryContact.suffix}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
          <label class="account_label" v-if="FormInputs.BusinessLabels || FormInputs.NonProfitLabels">Primary Phone</label>
          <label class="account_label" v-else>Phone Number</label>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
          <p class="account_p"><span v-if="AccountView.primaryContact.countryCode">(</span>{{ + AccountView.primaryContact.countryCode}}<span v-if="AccountView.primaryContact.countryCode">)</span> {{AccountView.primaryContact.areaCode }}<span v-if="AccountView.primaryContact.areaCode">-</span>{{AccountView.primaryContact.phone}}</p>
        </div>
      </div>
      <div class="row" v-show="FormInputs.ContactRole">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
          <label class="account_label" v-if="FormInputs.BusinessLabels">Role in Business</label>
          <label class="account_label" v-else>Role in Organization</label>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
          <p class="account_p" v-if="AccountView.primaryContact.title">{{AccountView.primaryContact.titleDesc}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
          <label class="account_label" v-if="FormInputs.BusinessLabels || FormInputs.IndividualLabels">Business Type</label>
          <label class="account_label" v-else>Organization Type</label>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
          <p class="account_p" v-if="AccountView.primaryContact.businessType">{{AccountView.primaryContact.businessTypeDesc}}</p>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-font-size-17" v-on:click="EditSection()">Edit</button>
      </div>
    </div>

    <loading-component v-if="isLoading"></loading-component>
    <!--Edit Mode START-->
    <div v-if="isModalShown">
      <div class="modal-mask" role="dialog">
        <div class="overlay-mask">
          <div class="modal-dialog modal-lg">
            <div class="modal-content modal-edit-bg">
              <div class="modal-body">
                <div v-if="isFormLoading" class="row">
                  <page-loader></page-loader>
                </div>
                <div v-else>
                  <div class="close_btn" v-on:click="CloseModal()"></div><br>
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <edit-account-info v-bind:AccountEdit="AccountEdit" :FormInputs="FormInputs" :AccountValidationResult="AccountValidationResult" :ContactValidationResult="ContactValidationResult" :BusinessTypeIndividual="BusinessTypeIndividual" :BusinessTypeBusiness="BusinessTypeBusiness" :BusinessTypeNonProfit="BusinessTypeNonProfit" :Suffix="Suffix" :RoleNonProfit="RoleNonProfit" :RoleBusiness="RoleBusiness" :State="State"></edit-account-info>
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17" v-on:click="SaveAccount()">Save </button>
                        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17" v-on:click="CloseModal()">Cancel</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EditAccountInfo from "@/components/portal/userAccount/accountEdit/EditAccountInfo";
import LoadingComponent from "@/components/shared/LoadingComponent";
import PageLoader from "@/components/shared/PageLoader";
export default {
  props: [
    "AccountView",
    "AccountEdit",
    "AccountValidationResult",
    "FormInputs",
    "Suffix",
    "RoleNonProfit",
    "RoleBusiness",
    "BusinessTypeNonProfit",
    "BusinessTypeBusiness",
    "BusinessTypeIndividual",
    "State",
    "isFormLoading"
  ],
  components: { EditAccountInfo, LoadingComponent, PageLoader },
  data() {
    return {
      isModalShown: false,
      ContactValidationResult: {},
      isLoading: false
    };
  },
  methods: {
    EditSection() {
      document.body.classList.add("body-overflow");
      this.ContactValidationResult = {};
      this.isModalShown = !this.isModalShown;
      this.$emit("load");
      this.$emit("clicked");
    },
    CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    },
    SaveAccount() {
      this.AccountEdit.eyeDoctors = null

      this.isLoading = true;
      this.ContactValidationResult = {};
      axios
        .post("/Account/AccountInformation", this.AccountEdit, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
        .then(response => {
          var _this = this;
          _this.isLoading = false;
          if (response.data.isSuccess == true) {
            _this.$emit("selfReload");
            _this.CloseModal();
            _this.$emit("success");
          } else {
            _this.ContactValidationResult = response.data.raw.primaryContact.validationResult;
            alert(response.data.errorMessage);
            console.log("Error in Saving!");
          }
        })
        .catch(function(error) {
          console.log(error);
          _this.$router.push({name: 'Error'});
        });
    }
  }
}
</script>



// WEBPACK FOOTER //
// AccountInfo.vue?1c4822a8